import { permisosMenuUser } from "src/app/pages/auth/constants/menuUsers.constant";
import { MenuItem } from "../interface/MenuItem.interface";

export const MENU_ROUTES: MenuItem[] = [
  // {
  //   path: '/admin/calendario',
  //   title: 'Calendario',
  //   type: 'link',
  //   iconType: 'fa-solid fa-calendar-days text-orange',
  //   permission: permisosMenuUser.CALENDARIO,
  // },
  {
    path: '/admin/registros',
    title: 'Registros',
    type: 'link',
    iconType: 'fa-solid fa-table-list text-purple',
    permission: permisosMenuUser.REGISTROS,
  },
  {
    path: '/admin/movimientos',
    title: 'Movimientos',
    type: 'link',
    iconType: 'far fa-id-badge text-primary',
    permission: permisosMenuUser.MOVIMIENTOS,
  },
  // {
  //   path: '/admin/entrevistas',
  //   title: 'Entrevistas',
  //   type: 'link',
  //   iconType: 'fa-solid fa-clipboard-user text-primary',
  //   permission: permisosMenuUser.ENTREVISTAS,
  // },
  // {
  //   path: '/admin/consejos-electorales',
  //   title: 'Consejos Electorales',
  //   type: 'link',
  //   iconType: 'fa-solid fa-diagram-project text-info',
  //   permission: permisosMenuUser.CONSEJOS_ELECTORALES
  // },
  // {
  //   path: '/admin/importador',
  //   title: 'Importador',
  //   type: 'link',
  //   iconType: 'fas fa-file-import',
  //   permission: permisosMenuUser.IMPORTADOR,
  // },
  {
    path: '/admin/reportes',
    title: 'Reportes',
    type: 'link',
    iconType: 'fa-solid fa-file-chart-column text-red',
    permission: permisosMenuUser.REPORTES,
  },
  // {
  //   path: '/admin/expedientes',
  //   title: 'Expedientes',
  //   type: 'link',
  //   iconType: 'fa-solid far fa-id-card text-orange',
  //   permission: permisosMenuUser.EXPEDIENTES
  // },
  // {
  //   path: '/admin/administracion',
  //   title: 'Administración',
  //   type: 'link',
  //   iconType: 'fa-solid far fa-id-badge text-black',
  //   permission: permisosMenuUser.ADMINISTRACION
  // },
];
